<template src="./Channel.html"></template>

<script>
	import Ad from '@/components/Ad/Ad';
	import BlockNavigation from '@/components/BlockNavigation/BlockNavigation';
	import Simple from '@/components/Simple/Simple';
	import Teaser from '@/components/Teaser/Teaser';
	import Slider from '@/components/Slider/Slider';
	import List from '@/components/List/List';
	import Link from '@/components/Link/Link';

	export default {
		components: {
			'hp-ad': Ad,
			'hp-block-navigation': BlockNavigation,
			'hp-teaser': Teaser,
			'hp-simple': Simple,
			'hp-slider': Slider,
			'hp-list': List,
			'hp-link': Link
		},
		props: {
			meta: {
				type: Object,
				required: true
			},
			navigation: {
				type: Array,
				default: function() {
					return [];
				}
			},
			elements: {
				type: Array,
				default: function() {
					return [];
				}
			}
		}
	};
</script>
